export default {
  pagination: {},
  funnel: null,
  tree: [],
  funnels: []
};
